function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Text, View, TouchableOpacity } from 'react-native';
import { getTestId } from '../utils/test-id';
import { styles } from './BaseToast.styles';
export function BaseToast({
  text1,
  text2,
  onPress,
  activeOpacity = 1,
  style,
  touchableContainerProps,
  contentContainerStyle,
  contentContainerProps,
  text1Style,
  text1NumberOfLines = 1,
  text1Props,
  text2Style,
  text2NumberOfLines = 1,
  text2Props,
  renderLeadingIcon,
  renderTrailingIcon
}) {
  return /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
    testID: getTestId('TouchableContainer'),
    onPress: onPress,
    activeOpacity: activeOpacity,
    style: [styles.base, styles.leadingBorder, style]
  }, touchableContainerProps), renderLeadingIcon && renderLeadingIcon(), /*#__PURE__*/React.createElement(View, _extends({
    testID: getTestId('ContentContainer'),
    style: [styles.contentContainer, contentContainerStyle]
  }, contentContainerProps), (text1?.length ?? 0) > 0 && /*#__PURE__*/React.createElement(Text, _extends({
    testID: getTestId('Text1'),
    style: [styles.text1, text1Style],
    numberOfLines: text1NumberOfLines,
    ellipsizeMode: "tail"
  }, text1Props), text1), (text2?.length ?? 0) > 0 && /*#__PURE__*/React.createElement(Text, _extends({
    testID: getTestId('Text2'),
    style: [styles.text2, text2Style],
    numberOfLines: text2NumberOfLines,
    ellipsizeMode: "tail"
  }, text2Props), text2)), renderTrailingIcon && renderTrailingIcon());
}